import { TRPCClientError } from '@trpc/client';

/**
 * The tRPC error `code` a procedure threw (e.g. `'CONFLICT'`, `'PRECONDITION_FAILED'`), or `undefined`
 * for anything that isn't a tRPC client error. Reads `TRPCClientError`'s own typed `data` rather than
 * casting `unknown`.
 *
 * Lives here rather than in an app so shared components that classify a failed mutation — the chat
 * attachment composer, for one — do not each need their own copy. The apps re-export it.
 */
export const getTRPCErrorCode = (error: unknown): string | undefined =>
  error instanceof TRPCClientError ? error.data?.code : undefined;
